export const LOGO_DARK_BG = "https://customer-assets.emergentagent.com/job_a4594d73-fa34-4eeb-ac0c-478ac60a5582/artifacts/yzk7f811_Asset%203%403x.png"; // WHITE text — for use ON dark backgrounds
export const LOGO_LIGHT_BG = "https://customer-assets.emergentagent.com/job_a4594d73-fa34-4eeb-ac0c-478ac60a5582/artifacts/fmbi1by0_Asset%202%403x.png"; // BLACK text — for use ON light backgrounds

// Official EBG Realty customer contact — change here to update the whole site.
export const CONTACT = {
    display: "+91 82644 46665",
    tel: "tel:+918264446665",
    whatsapp: "918264446665",
};
export const waLink = (msg = "Hi EBG Realty, I'd like to speak with an advisor.") =>
    `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(msg)}`;

export const BRAND = {
    name: "EBG Realty",
    tagline: "Advisory. Access. Address.",
    phone_in: "+91 82644 46665",
    phone_ae: "+91 82644 46665",
    email: "info@ebgrealty.in",
    india_address: "Mumbai, India",
    uae_address: "Mumbai, India",
};

export const CITIES_INDIA = ["Mumbai", "Delhi NCR", "Bengaluru", "Hyderabad", "Pune", "Chennai", "Punjab", "Goa"];
export const CITIES_UAE = ["Dubai", "Abu Dhabi"];
export const CITIES_ALL = [...CITIES_INDIA, ...CITIES_UAE];

export const PROPERTY_TYPES = ["Apartment", "Villa", "Penthouse", "Plot", "Land", "Commercial"];
export const PROPERTY_STATUS = ["Ready to Move", "Under Construction", "New Launch"];
